import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const LanguageRoute = ({ children }) => {
    const { lang } = useParams();
    const [isValidLanguage, setIsValidLanguage] = useState(null);

    useEffect(() => {
        const validateLanguage = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-languages`, { withCredentials: true });
                const validLanguages = response.data.map(lang => lang.code.toLowerCase());
                const valid = validLanguages.includes(lang.toLowerCase());
                setIsValidLanguage(valid);
                if (valid) {
                    try { localStorage.setItem('lang', lang.toLowerCase()); } catch (_) {}
                }
            } catch (err) {
                setIsValidLanguage(false);
            }
        };

        if (lang) {
            validateLanguage();
        } else {
            setIsValidLanguage(true); // If no language parameter, consider it valid
        }
    }, [lang]);

    if (isValidLanguage === null) {
        return <div>Loading...</div>;
    }

    if (!isValidLanguage) {
        return <Navigate to="/404" />;
    }

    return children;
};

export default LanguageRoute; 